import { MatDialogConfig } from "@angular/material/dialog";

export function getPosOverrideViewingTableConfirmationModalDialogConfig() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '400px';
    dialogConfig.panelClass = ['up-dialog-container', 'messageBox'];
    return dialogConfig;
}